import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type PageTitleProps = {
  title: string;
  /** Breadcrumb root label. Defaults to the brand. */
  subName?: string;
  /** Where the root crumb links. */
  subPath?: string;
  /** Optional page-level actions rendered on the right of the title row. */
  actions?: ReactNode;
};

const PageTitle = ({ title, subName = 'Prezynt', subPath = '/dashboard', actions }: PageTitleProps) => {
  return (
    <>
      <title>{`${title} | Prezynt Admin`}</title>
      <div className="page-title-box">
        <div className="page-title-box__main">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb pz-breadcrumb">
              <li className="breadcrumb-item">
                <Link to={subPath}>{subName}</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {title}
              </li>
            </ol>
          </nav>
          <h1 className="pz-page-title">{title}</h1>
        </div>
        {actions ? <div className="page-title-box__actions">{actions}</div> : null}
      </div>
    </>
  );
}

export default PageTitle
